/** English and Arabic labels for the Ford Performance / Racing category. */
export const PERFORMANCE_CATEGORY_NAMES = ['Performance', 'أداء'];

/** Ford Racing filter checkbox labels (EN / AR). */
export const RACING_CHECKBOX_LABEL = {
    en: 'Explore Ford Racing Parts',
    ar: 'استكشف قطع Ford Racing',
};

export function getRacingCheckboxLabel(language = 'en') {
    return language === 'ar' ? RACING_CHECKBOX_LABEL.ar : RACING_CHECKBOX_LABEL.en;
}

export function isPerformanceCategoryName(name) {
    const n = (name ?? '').toString().trim();
    return PERFORMANCE_CATEGORY_NAMES.includes(n);
}

/** Find Performance category id from API list (locale-agnostic). */
export function findPerformanceCategoryId(categories) {
    if (!Array.isArray(categories)) return null;
    const match = categories.find((c) => c && isPerformanceCategoryName(c.name));
    return match ? match.id : null;
}
